import Component from '../core/Component';

export const STATUS = {
    COLLAPSED: 'is-collapsed',
    EXPANDED: 'is-expanded'
}

export default class FilterGroup extends Component {

    constructor(element) {
        super(element);

        this.ref = {
            toggle: null,
            expand: null
        }
    }

    prepare() {
        if (this.ref.toggle) {
            this.ref.toggle.addEventListener('click', ::this.handleToggleClick);
        }
        if (this.ref.expand) {
            this.ref.expand.addEventListener('click', ::this.handleExpandClick);
        }
    }

    handleToggleClick(event) {
        event.preventDefault();
        this.toggle();
    }

    handleExpandClick(event) {
        event.preventDefault();
        this.expand();
    }

    toggle() {
        this.element.classList.toggle(STATUS.COLLAPSED);
    }

    expand() {
        this.element.classList.add(STATUS.EXPANDED);
    }
}